import { IUserPlanResponse } from '@creditflowresearch/user-plan/vo/IUserPlanResponse';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';

export enum UserPlanRequestStatus {
  Pending = 'pending',
  Approved = 'approved',
  Denied = 'denied',
}

export type IUserPlanRequestsState = {
  [key in UserPlanType]?: {
    plan: UserPlanType,
    status: UserPlanRequestStatus,
  }
};

export interface IUserPlanState extends IUserPlanResponse {
  requests: IUserPlanRequestsState,
  hasServerError?: boolean,
}
